/*
RajeshK 09/19/2022 2700539021 Fixed GAL (136,137,158,98) and field group table GAL-153
saikrishna 10/04/2022 2700539021 Fixed client maintenance and role management bugs JIra(229,232,33,34,49,56,58,393,94,95).
ashraf 10/06/2022 2700539021 fixed role based access on role management
ashraf 10/16/2022 2700539021 added code comments in search, add role
Raghu 10/26/2022 2700539021 Add Role input field fixes.
Raghu 10/27/2022 2700539021 Button styling Fixes.
ashraf   10/16/2022 2700539021 added code comments in search, add role
Akhlaque 10/26/2022 2700539021  renamed cancel button to reset
akhilaavvaru 10/27/2022 2700539021 role management UX changes
Raghu 10/28/2022 2700539021 Search Role button alignment and card styling fixes
Lalitha 10/26/2022 2700539021  renamed cancel button to reset
Ashraf 11/10/2022 2700539021 fixed fetching modules for reports
Ashraf 11/11/2022 2700539021 fixed module code for fetching module data
Ashraf 11/11/2022 2700539021 fixed Bre code for module dropdown
Ashraf 12/01/2022 2700539021 fixed window name column data for custom window
Lalitha 12/09/2022 2700539021  Added reusable backButtonText
Sohel 12/12/2022 2700524332 Implemented Copy Functionality
Sohel 12/12/2022 2700539021 Added Module Column and Window Name rename
Ashraf 12/14/2022 2700539021 Added role access for new modules
Ashraf 12/14/2022 2700539021 fixed role access for new modules
Ashraf 12/15/2022 2700539021 changed columns order
Ashraf 12/15/2022 2700539021 changed Custom Windows constant
Ashraf 12/15/2022 2700539021 changed columns order
Ashraf 12/15/2022 2700539021 fixed role based access.
Ashraf 12/16/2022 2700539021 fixed custom windows name under function window column.
Ashraf 12/19/2022 2700539021 fixed new business value for payload.
Ashraf 12/16/2022 2700539021 fixed Custom Windows name under function window column.
Ashraf 12/20/2022 2700539021 fixed role management custom windows access
Ashraf 12/20/2022 2700539021 fixed user role access
Dilip 12/21/2022 2700539021 added validation for role name
Dilip 12/21/2022 2700539021 added regularexpression for role name
Ashraf 12/21/2022 2700539021 fixed navigation issue after saving data
Dilip 12/21/2022 2700539021 added validation for role description
Dilip 12/21/2022 2700539021 added validation for role name
Dilip 01/04/2023 2700539021 added tooltip for save button
Dilip 01/05/2023  2700539021 added validation for rolename and description
sai Krishna 01/09/2023  2700539021 rename the back to search button name
Dilip 01/23/2023  2700539021 disabled role name while editing
Dilip 01/24/2023  2700539021 enabled role name while copying
Sohel 02/13/2023 2700539021 fixed role management Save issue
// Suresh Peddavoora 02/24/2023 2700539021 New UI changes
suresh peddavoora 02/27/2023 2700539021 New UI changes
suresh peddavoora 03/01/2023 2700539021 New UI changes
suresh peddavoora 03/02/2023 2700539021 responsive fields changes
sohel 03/06/2023 2700539021 Added validation message for existing value
Prakash 04/06/2023 2700539021 Fixed button alignments issue.
suresh peddavoora 04/06/2023 2700539021 fields alignments fixes
Prakash 10/04/2023 2700539021 fixed check box color
Sohel 04/10/2023 3031450488 Added role access for Look Up Maintenance and Translation Tables
Sohel 05/23/2023 2700539021 removed Module Field
Sohel 05/23/2023 2700539021 Fixed Sorted Issue
Sohel 05/29/2023 2700539021 Fixed Role Management Reset Issue
Sohel 05/30/2023 2700539021 Changed Window Code to window name
Akhila 06/05/2023 2700539021 unsaved changes bug fixed/implemented
Akhila 06/14/2023 2700539021 bug fix unsaved changes on save button
Ravi 06/26/2023 2700539021 fixed submit issue
Dilip-pds 10/27/2023 2700539021  implement roleAccess for billing indicator Maintenance
Sohel 12/11/2023 2700539021 Added Role Name  and description validation.
*/

import {
  Grid,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  FormHelperText,
} from '@material-ui/core';
import {Form, Formik} from 'formik';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import React, {useEffect, useState, useContext} from 'react';
import ErrorBoundaryForComponents from '../../../util/ErrorBoundaryForComponents';
import {ThemeContext} from '../../../themes/ThemeProvider';
import CustomTable from './CustomTable';
import {useDispatch, useSelector} from 'react-redux';
import * as Yup from 'yup';
import {
  postAddRoleData,
  ResetMessage as resetMessage,
  ResetStatus as resetStatus,
  getDropDownData,
  postWindowDetails,
  getAllRoleNames,
} from '../../../redux/reducers/RoleManagement/AddRole';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import PageLoader from '../../../components/PageLoader';
import {ErrorSnackbar} from '../../../components/CustomSnackBar';
import {MODULE} from '../../../constants/Lookup';
import {COMPANY_TYPE} from '../../../constants/Lookup';
import {getOptions} from '../../../util/GetDropDownOptions';
import {ArrowBack} from '@material-ui/icons';
import GuiAutoComplete from '../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../components/FormComponents/GuiTextField';
import {setAlertData} from '../../../redux/reducers/UnsavedChangesAlertReducer';
import {submissionStart} from '../../../redux/reducers/CommonActions/commonActions';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;

// to define a new role (2700539021)
const AddRole = ({
  setValue,
  roleId,
  setRecordFormatCode,
  moduleNames,
  isCopy,
  handleDirty,
  showAlertRef,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [selectedAll, setSelectedAll] = useState(false);
  const {companyCodeData} = useSelector(({addLetterData}) => addLetterData);
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const dispatch = useDispatch();
  const {
    addRoleStatus,
    windowDetails,
    isLoading,
    isWindowLoading,
    errorMsg,
    dropDownData,
    addRoleData,
    roleError,
    allRoleNames,
  } = useSelector(({addRole}) => addRole);
  const [tableData, setTableData] = useState([]);
  const [moduleValue, setModuleValue] = useState([]);
  const [module, setModule] = useState();
  const [parentValueCode, setParentValueCode] = useState([]);
  const [companyData, setCompanyData] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(15);

  // to prepopulate value to module, company code fields (2700552117)
  const getObjectModule = (options, option) => {
    const mappedCustomerCode = option?.reduce((acc, optionNum) => {
      for (const object2 in options) {
        if (options[object2]?.value === optionNum) {
          acc.push({
            value: optionNum,
          });
        }
      }
      return acc;
    }, []);
    return mappedCustomerCode;
  };

  // setting payload to fetch module detalis when the module field value changes (2700552117)
  useEffect(() => {
    if (module?.length > 0) {
      const getModuleValue = module
        ?.map((item) => item?.value?.toUpperCase().replaceAll(' ', '_'))
        ?.map((i) => (i === 'CLIENT_MAINTENANCE' ? 'CLIENT_MANAGEMENT' : i));
      const parentValue = getModuleValue?.map((item) =>
        item === 'REPORTING/EXPORT' ?
          'RE' :
          item === 'NEW_BUSINESS_MAINTENANCE' ?
            'NBM' :
            item === 'ACCOUNT_UPDATE' ?
              'AUG' :
              item === 'WORK_QUEUE_ACTIVITY' ?
                'WQA' :
                item === 'WORK_QUEUE_MAINTENANCE' ?
                  'WQM' :
                  item === 'WORK_QUEUE_SETUP' ?
                    'WQS' :
                    item === 'SCHEDULER' ?
                      'SC' :
                      item === 'ENABLE' ?
                        'EN' :
                        item === 'EXPORTS' ?
                          'ED' :
                          item === 'LETTERS' ?
                            'LM' :
                            item === 'IMPORTS' ?
                              'ID' :
                              item === 'OPERATIONS' ?
                                'OP' :
                                item === 'ADMINISTRATION' ?
                                  'AD' :
                                  item === 'CUSTOM_WINDOWS' ?
                                    'UD' :
                                    item === 'CUSTOM_WINDOW_SETUP' ?
                                      'CWS' :
                                      item === 'ROLE_MANAGEMENT' ?
                                        'RMM' :
                                        item === 'NB_MAINTENANCE' ?
                                          'NBM' :
                                          item === 'BUSINESS_RULE_ENGINE' ?
                                            'BR' :
                                            item === 'LOOKUP_MAINTENANCE' ?
                                              'LUM' :
                                              item === 'CLIENT_MANAGEMENT' ?
                                                'CLMGM' :
                                                item === 'CLIENT_AUDIT_FIELD_LIST' ?
                                                  'CAFL' :
                                                  item === 'BILLING_INDICATOR_MAINTENANCE' ? 'BIM' :
                                                    item?.includes('_') ?
                                                      item?.split('_')[0][0] + item?.split('_')[1][0] :
                                                      item?.split('')[0][0],
      );
      setParentValueCode(parentValue);
      setModuleValue(getModuleValue);
    } else {
      setModuleValue('');
    }
  }, [module]);

  // setting company code, module state values while prepopulating particular role data (2700552117)
  useEffect(() => {
    setCompanyData(addRoleData?.companyCode ? addRoleData.companyCode : '');
    // setModule(addRoleData?.moduleName ? addRoleData.moduleName.toUpperCase() : "");
  }, [addRoleData]);

  // prepopulating modules table data for selected role to view or edit (2700539021)
  useEffect(() => {
    const duplicateData = [];
    const coreDataArray = [];
    const getWindowCodes =
      addRoleData?.functionalities?.length > 0 ?
        addRoleData?.functionalities?.map((item) => {
          return item?.windowName;
        }) :
        [];
    addRoleData?.functionalities?.length > 0 ?
      windowDetails?.forEach((window) => {
        const val =
            window?.value && window?.valueCode ? window.value + ' ' + window?.valueCode : '';
        if (!duplicateData.includes(val)) {
          duplicateData.push(val);
          if (getWindowCodes.includes(window.valueCode)) {
            addRoleData?.functionalities?.forEach((item) => {
              if (window.valueCode === item.windowName) {
                coreDataArray.push({
                  key: window?.value ? window.value : '',
                  add: item.isAdd === 'Y',
                  delete: item.isDelete === 'Y',
                  update: item.isUpdate === 'Y',
                  code: item?.windowName,
                  favourite:
                      window?.moduleName === 'Core Windows' ||
                      window?.moduleName === 'Custom Windows' ?
                        item.isFavorite === 'Y' :
                        false,
                  view: item.isView === 'Y',
                  moduleName: window?.moduleName,
                });
              }
            });
          } else {
            coreDataArray.push({
              key: window?.value ? window.value : '',
              add: false,
              delete: false,
              update: false,
              code: window?.valueCode,
              favourite: false,
              view: false,
              moduleName: window?.moduleName,
            });
          }
        }
      }) :
      windowDetails?.forEach((each) => {
        const val = each?.value && each?.valueCode ? each.value + ' ' + each?.valueCode : '';
        if (!duplicateData.includes(val)) {
          duplicateData.push(val);
          coreDataArray.push({
            key: each?.value ? each.value : '',
            add: false,
            delete: false,
            update: false,
            code: each?.valueCode,
            favourite: false,
            view: false,
            moduleName: each?.moduleName,
          });
        }
      });

    const one = coreDataArray?.filter((i) => i?.view);
    const srt = one?.sort(function(a, b) {
      if (a.moduleName < b.moduleName) {
        return -1;
      }
      if (a.moduleName > b.moduleName) {
        return 1;
      }
      return 0;
    });
    const two = coreDataArray?.filter((i) => !i?.view);
    const finalArray = srt?.concat(two);
    setTableData(finalArray);
  }, [addRoleData, windowDetails]);

  // to get module field options from set of dropdown options (2700539021)
  const getModuleOptions = (typeCode) => {
    let label = [];
    label = dropDownData && dropDownData[typeCode] ? dropDownData[typeCode] : [];
    return label;
  };

  // initial values for add role form (2700539021)
  const initialValues = {
    roleName: isCopy ? '' : addRoleData?.roleName ? addRoleData?.roleName : '',
    roleDescription: isCopy ? '' : addRoleData?.roleDescription ? addRoleData?.roleDescription : '',
    module: moduleNames?.length > 0 ? getObjectModule(getModuleOptions(MODULE), moduleNames) : [],
    isActive: addRoleData?.isActive !== 'N',
    companyCode:
      companyData?.length > 0 ?
        getObjectModule(getOptions(COMPANY_TYPE, companyCodeData), companyData) :
        [],
  };

  const {roleData} = useSelector(({role}) => role);
  const disable = roleData?.window?.['Role Management']?.['RMM'];

  // state used when select all is checked (2700539021)
  const colSelectedArr = {
    add: tableData?.every((each) => each.add),
    update: tableData?.every((each) => each.update),
    delete: tableData?.every((each) => each.delete),
    view: tableData?.every((each) => each.view),
  };
  const [isAllSelectedObj, setIsAllSelectedObj] = useState(colSelectedArr);

  // fetch module details when module selection changes (2700552117)
  useEffect(() => {
    if (moduleValue?.length > 0) {
      dispatch(
        postWindowDetails({
          parentValueCode: parentValueCode,
          childTypeCode: moduleValue,
        }),
      );
    } else {
      setTableData([]);
    }
  }, [moduleValue]);

  // fetching existing roles data for field level validation, lookup dropdown data (2700539021)
  useEffect(() => {
    // dispatch(getDropDownData());
    dispatch(getAllRoleNames());
  }, [dispatch]);

  // reset redux state after successfull data post or when any error occurs, redirect to search role tab (2700539021)
  useEffect(() => {
    if (addRoleStatus === 200 || errorMsg || roleError) {
      addRoleStatus && setValue(0);
      setTimeout(() => {
        dispatch(resetStatus());
        dispatch(resetMessage());
      }, 2500);
    }
  }, [addRoleStatus, errorMsg, roleError]);

  // setting selected all state to true when isAllSelectedObj is true (2700539021)
  useEffect(() => {
    if (
      isAllSelectedObj.add &&
      isAllSelectedObj.update &&
      isAllSelectedObj.delete &&
      isAllSelectedObj.view
    ) {
      tableData?.length > 0 ? setSelectedAll(true) : setSelectedAll(false);
    } else {
      setSelectedAll(false);
    }
  }, [isAllSelectedObj]);

  const columns = [
    {title: 'Module'},
    {title: 'Function-Window'},
    {title: 'View'},
    {title: 'Add'},
    {title: 'Update'},
    {title: 'Delete'},
    {title: 'Is Favorite'},
  ];

  // resetting select all state to false (2700539021)
  useEffect(() => {
    tableData?.forEach((data, i) => {
      data.add = false;
      data.view = false;
      data.update = false;
      data.delete = false;
    });
    setSelectedAll(false);
  }, []);

  // handles table data when select all is checked or unchecked (2700539021)
  const allSelection = (eve, sel) => {
    if (sel === true) {
      setSelectedAll(true);
      tableData?.forEach((data, i) => {
        data.add = true;
        data.view = true;
        data.update = true;
        data.delete = true;
      });

      setIsAllSelectedObj({
        add: tableData?.every((each) => each.add),
        update: tableData?.every((each) => each.update),
        delete: tableData?.every((each) => each.delete),
        view: tableData?.every((each) => each.view),
      });
    } else {
      setSelectedAll(false);
      tableData?.forEach((data, i) => {
        data.add = false;
        data.view = false;
        data.update = false;
        data.delete = false;
      });
      setIsAllSelectedObj({
        add: tableData?.every((each) => each.add),
        update: tableData?.every((each) => each.update),
        delete: tableData?.every((each) => each.delete),
        view: tableData?.every((each) => each.view),
      });
    }
  };

  // handles add, view, delete, update values at row level, and updates select all if everything is checked (2700539021)
  const handleInputChange = (selection, i, eve, rowData) => {
    const nameT = eve.target.name;
    tableData?.forEach((data, i) => {
      if (
        eve.target.name === 'view' &&
        !selection &&
        data.code + data.key === rowData.code + data.key
      ) {
        data['view'] = false;
        data['update'] = false;
        data['add'] = false;
        data['delete'] = false;
        data['favourite'] = false;
      } else if (data.code + data.key === rowData.code + data.key) {
        data[nameT] = selection;
        if (eve.target.name !== 'view' && !data['view']) {
          data['view'] = selection;
        }
      }
    });
    setIsAllSelectedObj({
      add: tableData?.every((each) => each.add),
      update: tableData?.every((each) => each.update),
      delete: tableData?.every((each) => each.delete),
      view: tableData?.every((each) => each.view),
    });
  };

  // to check if all are selected when table data changes (2700539021)
  useEffect(() => {
    setIsAllSelectedObj({
      add: tableData?.every((each) => each.add),
      update: tableData?.every((each) => each.update),
      delete: tableData?.every((each) => each.delete),
      view: tableData?.every((each) => each.view),
    });
  }, [tableData]);

  // reset table data when reset button is clicked (2700539021)
  const handleTableData = () => {
    if (addRoleData?.roleId) {
      setModule(addRoleData?.moduleName ? addRoleData.moduleName : '');
      const duplicateData = [];
      const coreDataArray = [];
      const getWindowCodes =
        addRoleData?.functionalities?.length > 0 ?
          addRoleData?.functionalities?.map((item) => {
            return item?.windowName;
          }) :
          [];
      addRoleData?.functionalities?.length > 0 ?
        windowDetails?.forEach((window) => {
          const val =
              window?.moduleName === 'Custom Windows' ?
                window.valueCode :
                window?.value + ' ' + window?.valueCode;
          if (!duplicateData.includes(val)) {
            duplicateData.push(val);
            if (getWindowCodes.includes(window.valueCode)) {
              addRoleData?.functionalities?.forEach((item) => {
                if (window.valueCode === item.windowName) {
                  coreDataArray.push({
                    key:
                        window?.moduleName === 'Custom Windows' ? window.valueCode : window.value,
                    add: item.isAdd === 'Y',
                    delete: item.isDelete === 'Y',
                    update: item.isUpdate === 'Y',
                    code: item?.windowName,
                    favourite: item.isFavorite === 'Y',
                    view: item.isView === 'Y',
                    moduleName: window?.moduleName,
                  });
                }
              });
            } else {
              coreDataArray.push({
                key: window?.moduleName === 'Custom Windows' ? window.valueCode : window.value,
                add: false,
                delete: false,
                update: false,
                code: window?.valueCode,
                favourite: false,
                view: false,
                moduleName: window?.moduleName,
              });
            }
          }
        }) :
        windowDetails?.forEach((each) => {
          const val =
              each?.moduleName === 'Custom Windows' ?
                each.valueCode :
                each?.value + ' ' + each?.valueCode;
          if (!duplicateData.includes(val)) {
            duplicateData.push(val);
            coreDataArray.push({
              key:
                  each?.moduleName === 'Custom Windows' ?
                    each.valueCode :
                    each?.value + each?.valueCode,
              add: false,
              delete: false,
              update: false,
              code: each?.valueCode,
              favourite: false,
              view: false,
              moduleName: each?.moduleName,
            });
          }
        });
      if (moduleNames && moduleNames?.length > 0) {
        const getModuleValue = moduleNames
          ?.map((item) => item?.toUpperCase().replaceAll(' ', '_'))
          ?.map((i) => (i === 'CLIENT_MAINTENANCE' ? 'CLIENT_MANAGEMENT' : i));
        const parentValue =
          getModuleValue?.length > 0 &&
          getModuleValue?.map((item) =>
            item === 'REPORTING/EXPORT' ?
              'RE' :
              item === 'NEW_BUSINESS_MAINTENANCE' ?
                'NBM' :
                item === 'ACCOUNT_UPDATE' ?
                  'AUG' :
                  item === 'WORK_QUEUE_ACTIVITY' ?
                    'WQA' :
                    item === 'WORK_QUEUE_MAINTENANCE' ?
                      'WQM' :
                      item === 'WORK_QUEUE_SETUP' ?
                        'WQS' :
                        item === 'LETTERS' ?
                          'LM' :
                          item === 'SCHEDULER' ?
                            'SC' :
                            item === 'EXPORTS' ?
                              'ED' :
                              item === 'IMPORTS' ?
                                'ID' :
                                item === 'OPERATIONS' ?
                                  'OP' :
                                  item === 'ADMINISTRATION' ?
                                    'AD' :
                                    item === 'ENABLE' ?
                                      'EN' :
                                      item === 'CUSTOM_WINDOWS' ?
                                        'UD' :
                                        item === 'CUSTOM_WINDOW_SETUP' ?
                                          'CWS' :
                                          item === 'ROLE_MANAGEMENT' ?
                                            'RMM' :
                                            item === 'NB_MAINTENANCE' ?
                                              'NBM' :
                                              item === 'BUSINESS_RULE_ENGINE' ?
                                                'BR' :
                                                item === 'LOOKUP_MAINTENANCE' ?
                                                  'LUM' :
                                                  item === 'CLIENT_MANAGEMENT' ?
                                                    'CLMGM' :
                                                    item === 'CLIENT_AUDIT_FIELD_LIST' ?
                                                      'CAFL' :
                                                      item?.includes('_') ?
                                                        item?.split('_')[0][0] + item?.split('_')[1][0] :
                                                        item?.split('')[0][0],
          );
        setParentValueCode(parentValue);
        setModuleValue(getModuleValue);
      } else {
        setModuleValue('');
      }
      setTableData(coreDataArray);
    } else {
      setModuleValue('');
      setSelectedAll(false);
      tableData?.forEach((data, i) => {
        data.add = false;
        data.view = false;
        data.update = false;
        data.delete = false;
        data.favourite = false;
      });
      setIsAllSelectedObj({
        add: tableData?.every((each) => each.add),
        update: tableData?.every((each) => each.update),
        delete: tableData?.every((each) => each.delete),
        view: tableData?.every((each) => each.view),
      });
    }
  };

  // to check if entered role name already exist for field validation (2700539021)
  const checkNameExist = (value) => {
    if (allRoleNames && allRoleNames.length > 0 && value) {
      const ar = [];
      allRoleNames.filter((i) => {
        if (
          i?.roleName?.toLowerCase()?.trim() === value?.toLowerCase()?.trim() &&
          i?.isActive === 'Y'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const checkNameAlreadyExist = (value) => {
    if (allRoleNames && allRoleNames.length > 0 && value) {
      const ar = [];
      allRoleNames.filter((i) => {
        if (
          i?.roleName?.toLowerCase()?.trim() === value?.toLowerCase()?.trim() &&
          i?.isActive === 'N'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  // validations for add role form fields (2700539021)
  const schema = Yup.object().shape({
    roleName: Yup.string()
      .test('roleName', 'Role Name already exist', (value) =>
        value?.toLowerCase() === addRoleData?.roleName?.toLowerCase() && !isCopy ?
          true :
          !checkNameExist(value),
      )
      .test('roleName', 'Role Name has already been used in the past', (value) =>
        value?.toLowerCase() === addRoleData?.roleName?.toLowerCase() && !isCopy ?
          true :
          !checkNameAlreadyExist(value),
      )
      .required('Role name is required'),
    roleDescription: Yup.string()
      .required('Role description is required'),
    // module: Yup.mixed().test("module", "Module is required", (value) => {
    //   if (value?.length > 0 || value?.module) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // }),
    companyCode: Yup.mixed().test('companyCode', 'Company code is required', (value) => {
      if (value?.length > 0 || value?.companyCode) {
        return true;
      } else {
        return false;
      }
    }),
  });

  useEffect(() => {
    if (getModuleOptions(MODULE)?.length > 0) {
      setModule(getModuleOptions(MODULE));
    } else {
      setModule([]);
    }
  }, [getModuleOptions(MODULE)]);
  // save role data (2700539021)
  const handleSubmit = (values) => {
    dispatch(submissionStart());
    // code may required
    // let mulipleWindowObjArr = [];
    // const windows = tableData.map((item) => {
    //   const indexOfwindowStart = item.key.indexOf("(");
    //   const windows2 = item.key.slice(indexOfwindowStart);
    //   let windowsArr = windows2.slice(1, windows2.length - 1).replace(/\s/g, "").split(",");
    //   if (windowsArr.length > 1) {
    //     windowsArr.forEach((each, index) => {
    //       mulipleWindowObjArr.push({
    //         [windowsArr[index]]: {
    //           add: item.add,
    //           delete: item.delete,
    //           update: item.update,
    //           view: item.view,
    //           favourite: item.favourite,
    //         },
    //       });
    //     });
    //     windowsArr = [];
    //   } else {
    //     return {
    //       [item.code]: {
    //         add: item.add,
    //         delete: item.delete,
    //         update: item.update,
    //         view: item.view,
    //         favourite: item.favourite,
    //       },
    //     };
    //   }
    //   return;
    // }, {});

    // const finalMappedArr = [...windows, ...mulipleWindowObjArr];
    // const finalArrForPost = finalMappedArr.map((each) => {
    //   if (each !== undefined) {
    //     const key = Object.keys(each);
    //     return {
    //       isAdd: each[key[0]].add,
    //       isDelete: each[key[0]].delete,
    //       isFavorite: each[key[0]].favourite,
    //       isUpdate: each[key[0]].update,
    //       isView: each[key[0]].view,
    //       windowName: key[0],
    //     };
    //   } else {
    //     return false;
    //   }
    // });
    // finalArrForPost.filter((each) => typeof (each) === "object")

    const windows = tableData?.reduce(
      (obj, item) => ({
        ...obj,
        [item.code]: {
          add: item.add,
          delete: item.delete,
          update: item.update,
          view: item.view,
          favourite: item.favourite,
          moduleName: item.moduleName,
        },
      }),
      {},
    );

    const keys = Object.keys(windows);
    const finalArrForPost = keys.map((each) => {
      return {
        isAdd: windows[each]?.add ? 'Y' : 'N',
        isDelete: windows[each]?.delete ? 'Y' : 'N',
        isFavorite: windows[each]?.favourite ? 'Y' : 'N',
        isUpdate: windows[each]?.update ? 'Y' : 'N',
        isView: windows[each]?.view ? 'Y' : 'N',
        windowName: each,
        moduleName:
          windows[each]?.moduleName === 'Custom Windows' ?
            'Custom Windows' :
            windows[each]?.moduleName,
      };
    });
    const getCompanyCodes =
      values?.companyCode?.length > 0 ? values?.companyCode?.map((item) => item.value) : [];
    const passValues = {
      functionalities: finalArrForPost,
      roleDescription: values.roleDescription.trim(),
      roleName: values.roleName.trim(),
      roleId: isCopy ? 0 : roleId ? roleId : 0,
      isActive: values.isActive === true ? 'Y' : 'N',
      companyCode: getCompanyCodes || '',
      moduls:
        getModuleOptions(MODULE)?.length > 0 ?
          getModuleOptions(MODULE)?.map((el) => el.valueCode) :
          [],
    };
    dispatch(postAddRoleData(passValues));
    handleDirty(false, 'fixed');
  };
  return (
    <div>
      <div>
        <Formik
          onSubmit={(values) => {
            handleSubmit(values);
          }}
          initialValues={initialValues}
          validationSchema={schema}
          enableReinitialize
        >
          {(props) => {
            const {
              values,
              handleChange,
              handleBlur,
              setFieldValue,
              resetForm,
              touched,
              errors,
              dirty,
            } = props;
            handleDirty && handleDirty(dirty);
            return (
              <div>
                <Form autoComplete="off" noValidate>
                  <div className={`${classes.cardBordernoneStyles}`}>
                    <div className="button-table-spacing-mb justify-content-start  new-standard-textfields">
                      <Button
                        variant="outlined"
                        type="button"
                        disabled={isLoading}
                        className={`search-btn mx-1 ${classes.buttonRoot}`}
                        onClick={() => {
                          // setValue(0);
                          if (showAlertRef.current) {
                            dispatch(
                              setAlertData({
                                showAlert: showAlertRef.current,
                                alertCallback: () => {
                                  setValue(0);
                                },
                              }),
                            );
                          } else {
                            setValue(0);
                          }
                        }}
                      >
                        <ArrowBack className="mr-2" />
                        Back to Role list
                      </Button>
                    </div>
                    <ErrorBoundaryForComponents>
                      <Grid
                        className="form-row global-field-textfields new-standard-textfields"
                        container
                        spacing={2}
                      >
                        <>
                          <Grid item={true} xs={6} lg={4} xl={4} md={6} className="form-group">
                            <TextField
                              margin="dense"
                              variant="outlined"
                              placeholder={`Enter Role Name`}
                              label="Role Name"
                              className={` ${classes.labelName}`}
                              // InputLabelProps={{
                              //   shrink: true,
                              // }}
                              name="roleName"
                              value={values.roleName}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              inputProps={{maxLength: 25}}
                              fullWidth
                              required
                              disabled={
                                addRoleData?.isActive === 'N' || (addRoleData?.roleName && !isCopy)
                              }
                              touched={touched?.roleName}
                              error={Boolean(touched?.roleName && errors?.roleName)}
                            />
                            <FormHelperText variant="outlined">
                              {touched?.roleName && errors?.roleName}
                            </FormHelperText>
                          </Grid>
                          <Grid item={true} xs={6} lg={4} xl={4} md={6} className="form-group">
                            <TextField
                              margin="dense"
                              variant="outlined"
                              placeholder={`Enter Role Description`}
                              label="Role Description"
                              className={` ${classes.labelName}`}
                              // InputLabelProps={{
                              //   shrink: true,
                              // }}
                              name="roleDescription"
                              value={values.roleDescription}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              inputProps={{maxLength: 100}}
                              fullWidth
                              required
                              touched={touched.roleDescription}
                              error={Boolean(touched.roleDescription && errors.roleDescription)}
                            />
                            <FormHelperText variant="outlined">
                              {touched.roleDescription && errors.roleDescription}
                            </FormHelperText>
                          </Grid>
                          {/* <Grid
                            item={true}
                            xs={6}
                            lg={4} xl={4}
                            className={` form-group  autocomplete-field ${
                              values.module.length > 4 && "autocomplete-checkbox"
                            }`}
                          >
                            <GuiAutoComplete
                              classes={{
                                popper: classes.popper,
                                option: classes.option,
                              }}
                              className={` ${classes.labelName}`}
                              multiple
                              disableCloseOnSelect
                              limitTags={1}
                              name="module"
                              id="module"
                              size="small"
                              // className={`autocomplete-multiselect-label`}
                              value={values.module}
                              options={getModuleOptions(MODULE)}
                              getOptionSelected={(option, value) => {
                                return option?.value === value?.value;
                              }}
                              getOptionLabel={(option) => {
                                return option && option.value ? option.value : option;
                              }}
                              onChange={(e, value) => {
                                if (value) {
                                  setFieldValue("module", value);
                                  setModule(value);
                                } else {
                                  setFieldValue("module", "");
                                }
                              }}
                              renderOption={(option, { selected }) => (
                                <React.Fragment>
                                  <Checkbox
                                    icon={icon}
                                    checkedIcon={
                                      <CheckBoxIcon fontSize="small" className="selectcheckBox" />
                                    }
                                    checked={selected}
                                    className={classes.checkBox}
                                  />

                                  {option?.value ? option.value : ""}
                                </React.Fragment>
                              )}
                              renderInput={(params) => (
                                <div className="select-field company-code-label">
                                  <GuiTextField
                                    {...params}
                                    variant="outlined"
                                    margin="dense"
                                    // InputLabelProps={{
                                    //   shrink: true,
                                    // }}
                                    className={`autocomplete-multiselect-label`}
                                    required
                                    label="Module"
                                    placeholder="Select Module"
                                    touched={touched.module}
                                    error={Boolean(touched.module && errors.module)}
                                  />
                                </div>
                              )}
                            />
                            <FormHelperText variant="outlined">
                              {touched.module && errors.module}
                            </FormHelperText>
                          </Grid> */}
                          <Grid
                            item={true}
                            xs={6}
                            lg={4}
                            xl={4}
                            className={`form-group autocomplete-field ${
                              values.companyCode.length > 2 && 'autocomplete-checkbox-sm'
                            }`}
                          >
                            <GuiAutoComplete
                              classes={{
                                popper: classes.popper,
                                option: classes.option,
                              }}
                              multiple
                              disableCloseOnSelect
                              limitTags={1}
                              className={` ${classes.labelName}`}
                              name="companyCode"
                              id="companyCode"
                              size="small"
                              // className={`autocomplete-multiselect-label`}
                              value={values.companyCode}
                              options={getOptions(COMPANY_TYPE, companyCodeData)}
                              getOptionSelected={(option, value) => option?.value === value?.value}
                              getOptionLabel={(option) => {
                                return option && option?.value ? option?.value : option;
                              }}
                              onChange={(e, value) => {
                                if (value) {
                                  setFieldValue('companyCode', value);
                                } else {
                                  setFieldValue('companyCode', '');
                                }
                              }}
                              renderOption={(option, {selected}) => (
                                <React.Fragment>
                                  <Checkbox
                                    icon={icon}
                                    checkedIcon={
                                      <CheckBoxIcon fontSize="small" className="selectcheckBox" />
                                    }
                                    checked={selected}
                                    className={classes.checkBox}
                                  />
                                  {option?.value ? option.value : ''}
                                </React.Fragment>
                              )}
                              renderInput={(params) => (
                                <div className="select-field company-code-label">
                                  <GuiTextField
                                    className={`autocomplete-multiselect-label`}
                                    {...params}
                                    variant="outlined"
                                    margin="dense"
                                    // InputLabelProps={{
                                    //   shrink: true,
                                    // }}
                                    required
                                    label="Company Code"
                                    placeholder="Select Company Code"
                                    touched={touched.companyCode}
                                    error={Boolean(touched.companyCode && errors.companyCode)}
                                  />
                                </div>
                              )}
                            />
                            <FormHelperText variant="outlined">
                              {touched.companyCode && errors.companyCode}
                            </FormHelperText>
                          </Grid>
                          <Grid item={true} xs={6} md={4} lg={4} xl={4}>
                            <FormControlLabel
                              className={`${classes.checkRoot}`}
                              control={
                                <Checkbox
                                  name="isActive"
                                  checked={values.isActive}
                                  onChange={handleChange}
                                />
                              }
                              label={'Is Active'}
                            />
                          </Grid>
                          {/* {tableData?.length > 0 ? ( */}
                          <Grid item={true} lg={12} md={12} xs={12}>
                            <CustomTable
                              columns={columns}
                              data={tableData}
                              setTableData={setTableData}
                              handleChange={handleChange}
                              allSelection={allSelection}
                              handleInputChange={handleInputChange}
                              rowsPerPage={rowsPerPage}
                              setRowsPerPage={setRowsPerPage}
                              options={{search: true}}
                              className="custom-table"
                              selectedAll={selectedAll}
                              tableData={tableData}
                              isAllSelectedObj={isAllSelectedObj}
                            />
                          </Grid>
                          {/* ) : null} */}
                        </>
                      </Grid>
                    </ErrorBoundaryForComponents>
                    <div className="row justify-content-center mt-3 new-standard-textfields">
                      <Button
                        variant="outlined"
                        className={`mx-1 reset-btn ${classes.buttonRoot}`}
                        disabled={tableData?.length <= 0 || isLoading}
                        onClick={() => {
                          resetForm();
                          handleTableData();
                          if (!roleId) {
                            dispatch(getDropDownData());
                          }
                        }}
                      >
                        Reset
                      </Button>
                      {/* {values.module.length > 0 ? ( */}
                      <Button
                        type="submit"
                        variant="outlined"
                        disabled={
                          tableData?.length <= 0 ||
                          isLoading ||
                          (addRoleData && addRoleData?.isActive === 'N' && !values.isActive) ||
                          (!roleId && !disable?.add) ||
                          (roleId && !disable?.edit && !isCopy) ||
                          enabledSubmission
                        }
                        className={`mx-1 search-btn ${classes.buttonRoot}`}
                        color="primary"
                      >
                        Save
                      </Button>
                      {/* ) : (
                        <Tooltip title="Please select atleast one module">
                          <span>
                            <Button
                              type="submit"
                              variant="outlined"
                              className={`mx-1 search-btn ${classes.buttonRoot}`}
                              disabled
                            >
                              Save
                            </Button>
                          </span>
                        </Tooltip>
                      )} */}
                    </div>
                  </div>

                  {(isWindowLoading || isLoading) && <PageLoader />}
                  {(roleError || errorMsg) && <ErrorSnackbar errorMsg={roleError || errorMsg} />}
                </Form>
              </div>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default AddRole;
